import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';



@Component({
    selector: 'subtask-icon-renderer',
    template: `	
		<em>
			<div class="info-btn">
				<i class="fas fa-file-lines custom-icon" (click)="btnClickedHandler($event,'edit')"></i>
			</div>
		</em>`,
	styles: [`
		.info-btn{
			display: flex;
			gap: 0.8rem;
			color: #fff;
			cursor: pointer;
		}

		::ng-deep .custom-icon {
			/* background: linear-gradient(#000, rgb(49, 49, 49)); */
			border: 1px solid #676A6E;
			padding: 4px 4px 4px 4px;
			/* color: #fff; */
			cursor: pointer;
			background: transparent linear-gradient(180deg, #ffffff 0%, #e9f0f3 100%) 0% 0% no-repeat padding-box;
			opacity: 1;
			font: normal normal bold 10px;
			color: #676a6e;
		}
	`],
    standalone: false ,  // NOSONAR
})
export class SubTaskIconRenderer implements ICellRendererAngularComp, OnDestroy {

	

	refresh(_params: ICellRendererParams): boolean {
		return false;
	}

	private params: any;
	pageName;

	agInit(params: any): void {
		this.params = params;

	}

	btnClickedHandler(_event, action) {

		console.info("params",this.params);
		
		this.params.clicked(this.params.data.taskID, action);


		this.pageName = this.params.colDef.field;
		console.info("this is from",this.pageName);
		console.info("icon" + action + "was clicked");
	

		//open subtask page
		this.params.context.componentParent.openSubTask(this.params.data.taskID, this.params.data.description);
	



	}

	ngOnDestroy() { // NOSONAR

		// do something
	}
}
